<template>
  <div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="create_time"
		      label="充值时间"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="user_name"
		      label="用户昵称"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="account"
		      label="手机号"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="price"
		      label="充值金额(元)"
		      align="center"
        >
		    </el-table-column> 
		    <el-table-column
		      prop="recharge_reward_amount"
		      label="赠送金额(元)"
		      align="center"
        >
		    </el-table-column> 
		  </el-table>
			  <common-pagination
		    :total="total"
	      :page_size="page_size"
		    @size-change="handelPagesizeChange"
		    @page-change="handlePageChange"
		  ></common-pagination>
    </div>
  </div>
</template>

<script>
import { rechargeRecordsList } from '@/api/recharge-manage';
import CommonPagination from '@/components/CommonPagination';

export default {
  name: 'rechargerecord',
  data() {
  	return {
      tableData: [],
  		page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  mounted() {
     this.getRechargeRecordsList();
  },
  components: {
    CommonPagination,
  },
  methods: {
    async getRechargeRecordsList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size,
      };
      const { status, data } = await rechargeRecordsList(postData);
      if (status !== 200) return
      this.total = data.total;
      this.tableData = data.data;
      console.log(data, 'record')
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getRechargeRecordsList();
    },
    handlePageChange(page) {
    	this.page_index = page;
    	this.getRechargeRecordsList();
    }
  }
}
</script>

<style lang="less" scoped>
.table-wrap {
	margin-top: 30px;
}

</style>
